import React from "react";
import PropTypes from "prop-types";
import { CardImage } from "../../atoms/card-image";
import { SectionName } from "../../atoms/section-tag";
import { Headline } from "../../atoms/headline";
import { Subheadline } from "../../atoms/subheadline";
import { TimeStamp } from "../../atoms/time-stamp";
import Authors from "../../atoms/authors";
import "./two-col-story-card.m.css";

export const TwoColStoryCard = ({ story }) => {
  return (
    <div styleName="first-story-wrapper">
      <div styleName="hero-image">
        <CardImage story={story} />
      </div>
      <div styleName="content-wrapper">
        <div styleName="section">
          <SectionName story={story} />
        </div>
        <div styleName="headline">
          <Headline story={story} headlineColor={"#fff"} externalLink={true} />
        </div>
        <div styleName="subheadline">
          <Subheadline story={story} subheadlineColor={"#fff"} />
        </div>
        <div styleName="time-social">
          <div styleName="author">
            <Authors story={story} authorColor={"#fff"} />
            <TimeStamp story={story} timestampColor={"#fff"} />
          </div>
        </div>
      </div>
    </div>
  );
};

TwoColStoryCard.propTypes = {
  story: PropTypes.object
};
